<template>
  <el-row class="refund_framework">
    <el-table :data="orderList" style="width: 100%" @selection-change="selectOrder">
      <template slot="empty">
        <span class="emptyText">暂无待退款订单信息</span>
      </template>
      <el-table-column align="center" type="selection" width="18">
      </el-table-column>
      <el-table-column align="left" width="400">
        <template slot="header">
          <el-row>
            <el-button-group>
              <el-button class="small_button" size="small" type="primary" @click="acceptRefundAll">同意退款</el-button>
              <el-button class="small_button" size="small" type="danger" @click="refuseRefundAll">拒绝退款</el-button>
            </el-button-group>
          </el-row>
        </template>
        <template slot-scope="scope">
          <el-card class="order_card" shadow="hover">
            <el-row>
              <div class="clearfix">
                <el-col :span="16">
                  <el-row>
                    <el-col :span="24">
                      <p class="order_title">待退款订单&nbsp;#{{scope.row.id.substring(scope.row.id.length-4)}}</p>
                    </el-col>
                    <el-col :span="24">
                      <p class="order_address">{{scope.row.addressDetail + '--' + scope.row.addressNote}}</p>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-button class="order_status" type="text">
                    <span>进行中</span>
                  </el-button>
                </el-col>
              </div>
            </el-row>
            <el-divider></el-divider>
            <order-card :orderInfo=scope.row></order-card>
            <el-row type="flex" justify="center">
              <el-col :span="5">
                <el-button class="button" type="primary" @click="acceptRefund(scope.row)">同意退款</el-button>
              </el-col>
              <el-col :span="5">
                <el-button class="button" type="danger" @click="refuseRefund(scope.row)">拒绝退款</el-button>
              </el-col>
            </el-row>
          </el-card>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="pageData.currentPage" :page-sizes="[10, 50, 100]" :page-size="pageData.pageSize" :total="pageData.totalSize" layout="sizes, prev, pager, next, total" @size-change="changeSize" @current-change="changeCurrent">
    </el-pagination>
  </el-row>
</template>

<script>
import OrderCard from "../OrderCard.vue"
import DataUntils from "@/utils/data.js";

export default {
  name: "PendingRefund",
  components: {
    OrderCard,
  },
  data() {
    return {
      orderStatus: {
        status: "待退款"
      },
      orderList: [],
      orderSelection: [],
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条目个数
        totalSize: 0, //总条目数
      }
    };
  },
  created() {
    this.getOrderList();
  },
  mounted() {},
  watch: {
    // orderList: {
    //   handler: function () {
    //     this.$emit('refundCount', this.pageData.totalSize);
    //   }
    // }
    "pageData.totalSize"() {
      // this.$emit('refundCount', this.pageData.totalSize);
      this.getOrderList();
    }
  },
  methods: {
    getOrderList() {
      DataUntils
          .getOrderListByStatus({
            status: this.orderStatus.status,
            page:this.pageData.currentPage,
            pageSize: this.pageData.pageSize
          })
          .then((res) => {
            this.orderList = res.orderList;
            // this.pageData = res.pageData;
            this.pageData.totalSize = res.pageData.totalSize;
          })
    },
    async acceptRefund(val) {
      await DataUntils
          .acceptRefundByID({
            orderId: val.id
          });
      this.$notify({
        title: '订单同意退款通知',
        message: `订单#${val.id.substring(val.id.length-4)}已同意退款`,
        duration: 3000
      });
      // this.orderList = DataUntils.deleteItemFromArray(val, this.orderList);
      this.getOrderList();
    },
    acceptRefundAll() {
      if (this.orderSelection.length == 0) {
        this.$message({
          message: '未选择订单',
          type: 'error'
        });
      }
      else {
        this.$confirm(`您一共选择了${this.orderSelection.length}件订单`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: "success",
        })
            .then(() => {
              let orderArray = this.orderList;
              for (let i = 0; i < this.orderSelection.length; i++) {
                DataUntils
                    .acceptRefundByID({
                      orderId: this.orderSelection[i].id
                    });
                orderArray = DataUntils.deleteItemFromArray(this.orderSelection[i], orderArray);
              }
              this.orderList = orderArray;
              this.pageData.totalSize -= this.orderSelection.length;
              this.$notify({
                title: '订单同意退款通知',
                message: `${this.orderSelection.length}件订单已同意退款`,
                duration: 3000
              });
              this.getOrderList();
            });
      }
    },
    async refuseRefund(val) {
      await DataUntils
          .refuseRefundByID({
            orderId: val.id
          });
      this.$notify({
        title: '订单拒绝退款通知',
        message: `订单#${val.id.substring(val.id.length-4)}已拒绝退款`,
        duration: 3000
      });
      this.orderList = DataUntils.deleteItemFromArray(val, this.orderList);
      this.getOrderList();
    },
    refuseRefundAll() {
      if (this.orderSelection.length == 0) {
        this.$message({
          message: '未选择订单',
          type: 'error'
        });
      }
      else {
        this.$confirm(`您一共选择了${this.orderSelection.length}件订单`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: "error",
        })
            .then(() => {
              let orderArray = this.orderList;
              for (let i = 0; i < this.orderSelection.length; i++) {
                DataUntils
                    .acceptRefundByID({
                      orderId: this.orderSelection[i].id
                    });
                orderArray = DataUntils.deleteItemFromArray(this.orderSelection[i], orderArray);
              }
              this.orderList = orderArray;
              this.pageData.totalSize -= this.orderSelection.length;
              this.$notify({
                title: '订单拒绝退款通知',
                message: `${this.orderSelection.length}件订单已拒绝退款`,
                duration: 3000
              });
              this.getOrderList();
            });
      }
    },
    selectOrder(val) {
      this.orderSelection = val;
    },
    // 每页显示条目个数更改
    changeSize(pageSize) {
      this.pageData.pageSize = pageSize;
      this.pageData.currentPage = 1;
      this.getOrderList();
    },
    // 当前页数更改
    changeCurrent(currentPage) {
      this.pageData.currentPage = currentPage;
      this.getOrderList();
    },
  },
};
</script>

<style>
@import "../../../../style/Order.css";
</style>
